module.exports = __webpack_public_path__ + "static/bg-nb-hero-8bfb8cb3355894d9a73a535bfb9d546c.png";